import { apiRequest } from "../util/apiUtils";

export const privacyDetails = async (payload) => {
  try {
    const res = await apiRequest("get", "privacy-control/details", {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const privacyUpdate = async (payload) => {
  try {
    const res = await apiRequest("put", "privacy-control/edit", {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};
